<template>
    <div>
        <div class="mt-4">
            <p class="font-weight-light title text-center">DAFTAR PESANAN</p>
        </div>
        <div class="ma-4">
            <v-divider v-if="listPesanan.length > 0" class="mb-4"></v-divider>
            <v-row width="100%">
              <v-col cols="12" sm="6" md="12" class="text-center">
                  <v-text-field hint="Tekan Enter untuk mencari customer" persistent-hint v-model="inputSearch" @keyup.enter="searchUser" label="Masukkan Email / Telp Customer"></v-text-field>
                  <template v-if="userFound">
                    <v-card width="100%" outlined color="green darken-1" dark class="white--text mt-5">
                      <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption font-weight-bold">Data User Ditemukan</span>
                      <v-divider></v-divider>
                      <p class="mx-2 mb-0 caption">Nama: {{ dataCustomer.name }}</p>
                      <p class="mx-2 mb-0 caption">Email: {{ dataCustomer.email }}</p>
                      <p class="mx-2 mb-0 caption">Phone: {{ dataCustomer.telp }}</p>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-card width="100%" outlined color="orange darken-1" dark class="white--text mt-5">
                      <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Data user tidak ditemukan</span>
                      <v-divider></v-divider>
                      <p class="ma-2 caption">Maaf, email atau nomor telepon user tidak ditemukan.</p>
                    </v-card>
                  </template>
                  <!-- <v-btn class="ma-2" color="primary" @click="setDialogRegis(true)">
                      Register
                  </v-btn> -->
                  <!-- <v-btn class="ma-2" color="success" @click="setDialogLogin(true)">
                      Login
                  </v-btn> -->
              </v-col>
              <v-col cols="12" sm="6" md="12" class="text-center">
                <a href="/registrasi" target="blank" class="text-decoration-none mr-3">Belum punya akun?</a>
                <!-- <a href="#" @click="[forgotPasswordDialogVisible = true]" class="text-decoration-none">Lupa sandi?</a> -->
              </v-col>
            </v-row>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-divider class="mb-4 mt-4"></v-divider>
              <!-- <v-row width="100%" v-if="listPesanan.length > 0">
                <v-col cols="6" sm="3" md="6">
                  <v-text-field hint="Tekan Enter untuk mencari user" class="pt-0 mt-0" persistent-hint v-model="inputSearch" @keyup.enter="searchUser" label="Masukkan Email / Telp User"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="6" class="pt-0 pb-0" v-if="!newUser && !userFound">
                  <v-card width="100%" outlined color="blue darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Cari Data Customer</span>
                    <v-divider></v-divider>
                    <p class="ma-2 caption">Masukkan email atau telepon user.</p>
                  </v-card>
                </v-col>
                <v-col cols="6" sm="3" md="6" class="pt-0 pb-0" v-if="newUser">
                  <v-card width="100%" outlined color="orange darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Data user tidak ditemukan</span>
                    <v-divider></v-divider>
                    <p class="ma-2 caption">Maaf, email atau nomor telepon user tidak ditemukan.</p>
                  </v-card>
                </v-col>
                <v-col cols="6" sm="3" md="6" class="pt-0 pb-0" v-if="userFound">
                  <v-card width="100%" outlined color="green darken-1" dark class="white--text">
                    <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption font-weight-bold">Data User Ditemukan</span>
                    <v-divider></v-divider>
                    <p class="mx-2 mb-0 caption">Nama: {{ dataCustomer.name }}</p>
                    <p class="mx-2 mb-0 caption">Email: {{ dataCustomer.email }}</p>
                    <p class="mx-2 mb-0 caption">Phone: {{ dataCustomer.telp }}</p>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider class="my-4" v-if="listPesanan.length > 0"></v-divider> -->
              <!-- <v-row width="100%" v-if="listPesanan.length > 0"> -->
                <!-- <v-col cols="6" sm="3" md="6" class="pt-0 mt-0" v-if="newUser">
                  <v-text-field v-model="dataCustomer.name" :rules="[ v => !!v || 'Required.']"  class="pt-0 mt-0" @input="onChangeDataCustomer" label="Name"></v-text-field>
                </v-col> -->
                <!-- <v-col cols="6" sm="3" md="6" class="pt-0 mt-0" v-if="newUser">
                  <v-text-field v-model="dataCustomer.username" class="pt-0 mt-0" label="Username"></v-text-field>
                </v-col> -->
                <!-- <v-col cols="6" sm="3" md="6" class="pt-0 mt-0" v-if="newUser">
                  <v-autocomplete
                    v-model="dataCustomer.role_id"
                    @change="onChangeDataCustomer"
                    :items="roles"
                    :rules="[ v => !!v || 'Required.']"
                    item-text='name'
                    item-value='id'
                    label="Tipe User"
                    class="pt-0 mt-0"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" sm="3" md="6" class="pt-0 mt-0" v-if="newUser">
                  <v-text-field 
                  :disabled="isEmail" 
                  v-model="dataCustomer.email"
                  @input="onChangeDataCustomer" 
                  :rules="[ 
                      v => !!v || 'Required.',
                      v => rule.email || 'Invalid e-mail.'
                  ]"
                  class="pt-0 mt-0" 
                  label="Email">
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="6" class="pt-0 mt-0" v-if="newUser">
                  <v-text-field :disabled="isTelp" type="number" v-model="dataCustomer.telp" @input="onChangeDataCustomer" class="pt-0 mt-0" label="Telp"></v-text-field>
                </v-col> -->
                <!-- <v-col cols="12" sm="6" md="12" v-if="newUser">
                  <v-text-field type="password" v-model="dataCustomer.password" label="Password"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="12" v-if="newUser">
                  <v-text-field type="password" v-model="dataCustomer.password_conf" label="Confirmation"></v-text-field>
                </v-col> -->
                <!-- <v-col cols="12" sm="6" md="12" v-if="userFound">                    
                  <v-autocomplete
                    v-model="dataCustomer.roles[0].id"
                    :items="roles"
                    item-text='name'
                    item-value='id'
                    label="Choose a Role"
                  ></v-autocomplete>
                </v-col> -->
              <!-- </v-row> -->
              <div v-for="(list, index) of listPesanan" :key="index">
                  <div class="d-block">
                      <v-row>
                          <v-col cols="12" sm="8" md="8" class="py-0" style="align-self: center">
                              <p class="subtitle-2 mb-0">{{index+1}}. {{list.item_name}}</p>
                          </v-col>
                          <v-col cols="12" sm="4" md="4" class="py-0" style="text-align: right">
                              <v-btn outlined x-small fab color="red" @click="removePesanan(index)">
                                  <v-icon>delete</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </div>
                  <div>
                      <v-row class="pb-3">
                          <v-col cols="12" sm="5" md="5" class="pa-0 mr-0">
                              <p class="caption ml-6" v-if="list.mulai && list.mulai">@ Rp. {{list.harga_jual}} <br /> Mulai: {{list.mulai.substring(0, 16)}} <br /> Selesai: {{list.selesai.substring(0, 16)}} </p>
                              <p class="caption ml-6 mt-6" v-else>@ Rp. {{list.harga_jual}}</p>
                          </v-col>

                          <v-col cols="12" sm="3" md="3" class="pa-0">
                              <v-text-field
                                  v-if="list.type == 'UNMANAGE'"
                                  class="styled-input"
                                  type="number"
                                  v-model="list.qty"
                                  :rules="[ 
                                      v => Number(v) > 0 || 'Harus lebih dari 0'
                                  ]"
                                  @input="calculateTotal()"
                                  label="Jumlah"
                                  outlined
                              ></v-text-field>
                              <v-text-field
                                  v-else
                                  class="styled-input"
                                  type="number"
                                  v-model="list.qty"
                                  :rules="[ 
                                      v => Number(v) <= Number(list.stock) || 'Melebihi jumlah stok ' + list.stock, 
                                      v => Number(v) > 0 || 'Harus lebih dari 0'
                                  ]"
                                  @input="calculateTotal()"
                                  label="Jumlah"
                                  outlined
                              ></v-text-field>
                          </v-col>

                          <!-- <v-col cols="12" sm="2" md="2" class="pa-0">
                              <v-text-field
                                  class="styled-input"
                                  type="number"
                                  v-model="list.discount"
                                  @input="calculateTotal()"
                                  label="Diskon"
                                  suffix="%"
                                  outlined
                              ></v-text-field>
                          </v-col> -->
                          <v-col cols="12" sm="4" md="4" class="pa-0 pr-3">
                              <p class="caption mt-6 text-right">Rp. {{Number(list.harga_jual) * (1-(Number(list.discount) / 100)) * Number(list.qty)}}</p>
                          </v-col>
                      </v-row>
                  </div>
              </div>
            </v-form>
        </div>
        <div class="mt-4" v-if="!listPesanan.length > 0">
            <p class="font-weight-light subtitle-2 text-center">Tidak ada pesanan.</p>
        </div>
        <v-row class="mb-12"></v-row>
        <v-footer
            absolute
            color="teal darken-3 white--text"
            class="font-weight-medium py-0"
        >
            <v-row>
                <v-col cols="12" sm="6" md="3" style="align-self: flex-end;">
                    <v-btn :disabled="!dataCustomer" small color="red" class="white--text mb-0 mr-1" @click="logOut()">
                        <v-icon>logout</v-icon> Logout
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <p class="title text-right mb-0">Total: </p>
                </v-col>
                <v-col cols="12" sm="6" md="6" style="text-align: end">
                    <p class="title mb-0">Rp. {{totalHargaPesanan}}</p>
                    <v-btn :disabled="!listPesanan.length > 0" small color="orange" class="white--text mb-0 mr-1" @click="resetPesanan()">
                        <v-icon>close</v-icon> Reset
                    </v-btn>
                    <v-btn :disabled="!listPesanan.length > 0 || !valid || dataCustomer == null" small color="green" class="white--text mb-0" @click="checkCompanyActive()">
                        <v-icon>check</v-icon> Checkout
                    </v-btn>
                </v-col>
            </v-row>
        </v-footer>
        <v-dialog v-model="dialogOrderFor" max-width="500px">
          <v-card>
            <v-card-title>
                <span>Untuk siapa order ini dibuat?</span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange darken-1" text @click="[setSubmissionForCompany(false), createPesanan(), dialogOrderFor = !dialogOrderFor]">Saya pribadi</v-btn>
              <v-btn color="blue darken-1" text @click="[setSubmissionForCompany(true), createPesanan(), dialogOrderFor = !dialogOrderFor]">Perusahaan saya</v-btn>
              <!-- <v-btn v-if="dataCustomer && dataCustomer.company_id == userLogin.company_id" color="teal darken-1" text @click="[setSubmissionForCompany(false), pilihCustomer(), dialogOrderFor = !dialogOrderFor]">Customer saya</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPilihCustomer" max-width="500px">
          <v-card>
            <v-card-title>
              Pilih Customer
            </v-card-title>
            <v-card-text>
              <v-text-field hint="Tekan Enter untuk mencari customer" persistent-hint v-model="inputSearch" @keyup.enter="searchUser" label="Masukkan Email / Telp Customer"></v-text-field>
              <template v-if="userFound">
                <v-card width="100%" outlined color="green darken-1" dark class="white--text mt-5">
                  <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption font-weight-bold">Data User Ditemukan</span>
                  <v-divider></v-divider>
                  <p class="mx-2 mb-0 caption">Nama: {{ dataNewCustomer.name }}</p>
                  <p class="mx-2 mb-0 caption">Email: {{ dataNewCustomer.email }}</p>
                  <p class="mx-2 mb-0 caption">Phone: {{ dataNewCustomer.telp }}</p>
                </v-card>
              </template>
              <template v-else>
                <v-card width="100%" outlined color="orange darken-1" dark class="white--text mt-5">
                  <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Data user tidak ditemukan</span>
                  <v-divider></v-divider>
                  <p class="ma-2 caption">Maaf, email atau nomor telepon user tidak ditemukan.</p>
                </v-card>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="[dialogPilihCustomer = false]">Cancel</v-btn>
              <v-btn v-if="userFound" color="blue darken-1" text @click="[dialogPilihCustomer = false, createPesanan()]">Checkout</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
         <v-dialog v-model="forgotPasswordDialogVisible" max-width="500px">
          <v-card>
            <v-card-title>
                <span>Setel Ulang Kata Sandi</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="emailForgotPassword" 
                label="Masukkan email akun anda"
                required
                prepend-icon="mdi-email"
                type="email"
                :rules="[ 
                  v => !!v || 'Required.',
                  v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid.'
                ]"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="[forgotPasswordDialogVisible = false]">Batal</v-btn>
              <v-btn color="blue darken-1" text @click="sendEmailForgotPassword">Kirim</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isNumber, findIndex } from "lodash";
import dayjs from "dayjs";
import moment from 'moment';
import firebase from "../firebaseConfig.js";
const db = firebase.database();
export default {
    name: "HalamanOrder",
    data: () => ({
        total: 0,
        rule: {
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            },
        },
        valid: true,
        newUser: false,
        roles: [],
        isEmail: false,
        isTelp: false,
        dialogOrderFor: false,
        userLogin: JSON.parse(window.localStorage.getItem('user_data')),
        forgotPasswordDialogVisible: false,
        emailForgotPassword: '',
        dialogPilihCustomer: false,
        dataNewCustomer: {}
    }),
    computed: {
        ...mapGetters({
            getRoles: "user/getRoles"
        }),
        ...mapState({
            listPesanan: state => state.products.listPesanan,
            totalHargaPesanan: state => state.products.totalHargaPesanan,
            submissionForCompany: state => state.products.submissionForCompany,
        }),
        dataCustomer: {
            get () {
                return this.$store.state.pesanan.selectedCustomer
            },
            set (value) {
                this.setCustomer(value)
            }
        },
        userFound: {
            get () {
                return this.$store.state.pesanan.userFound
            },
            set (value) {
                this.setUserFound(value)
            }
        },
        inputSearch: {
            get () {
                return this.$store.state.pesanan.inputSearch
            },
            set (value) {
                this.setInputSearch(value)
            }
        }
    },
    async mounted(){
        const getRoles = await this.getRoles
        for(let role of getRoles.data.attributes){
            this.roles.push({
                name: role.name == 'unverified' ? 'Personal' : 'Company',
                id: role.id
            })
        }

        this.setListPesanan(JSON.parse(window.localStorage.getItem('listPesanan')))
        this.valid = window.localStorage.getItem('validatorOrder') == 'true' ? true : false
        this.dataCustomer = JSON.parse(window.localStorage.getItem('dataCustomer')) == undefined ? null : JSON.parse(window.localStorage.getItem('dataCustomer'))
        this.newUser = window.localStorage.getItem('newUser') == 'true' ? true : false
        this.userFound = window.localStorage.getItem('userFound') == 'true' ? true : false
        this.isTelp = window.localStorage.getItem('isTelp') == 'true' ? true : false
        this.isEmail = window.localStorage.getItem('isEmail') == 'true' ? true : false
        this.inputSearch = window.localStorage.getItem('inputSearch') == undefined ? null : window.localStorage.getItem('inputSearch')
    },
    methods: {
        ...mapMutations({
            showSnackbar: "showSnackbar",
            showLoading: "showLoading",
            closeLoading: "closeLoading",
            setTotalHargaPesanan : "products/SET_TOTAL_HARGA_PESANAN",
            setListPesanan : "products/SET_LIST_PESANAN",
            setListProduct : "products/SET_LIST_PRODUCT",
            setListOrder : "pesanan/SET_LIST_ORDER",
            setDialogOrder: "pesanan/SET_DIALOG_ORDER",
            setIdDialogOrder: "pesanan/SET_ID_DIALOG_ORDER",
            setDialogPayment : "pesanan/SET_DIALOG_PAYMENT",
            setJumlahPayment : "pesanan/SET_JUMLAH_PAYMENT",
            setDialogLogin: "pesanan/SET_DIALOG_LOGIN",
            setDialogRegis: "pesanan/SET_DIALOG_REGIS",
            setCustomer: "pesanan/SET_CUSTOMER",
            setUserFound: "pesanan/SET_USER_FOUND",
            setInputSearch: "pesanan/SET_INPUT_SEARCH",
            setSubmissionForCompany: "products/SET_SUBMISSION_FOR_COMPANY"
        }),
        ...mapActions({
            calculateTotal: "products/calculateTotal",
            resetPesanan: "products/resetPesanan",
            checkoutPesanan: "products/checkoutPesanan",
            dataProducts: "products/getProducts",
            getPesanans: "pesanan/getPesanans",
            detailOrder: "pesanan/detailOrder",
            createUser: "user/createUser",
            getUserById: "user/getUserById",
            getUsersByEmailOrPhone: "user/getUsersByEmailOrPhone",
            createJadwal: "jadwal/createJadwal",
            forgotPassword: "user/forgotPassword",
            cekJadwal: "jadwal/cekJadwal", 
        }),
        checkCompanyActive(){
            if(this.dataCustomer && ((this.dataCustomer.activated == 1 && this.dataCustomer.company_id != 0) || this.dataCustomer.company_id == this.userLogin.company_id)){
                this.dialogOrderFor = true
            }else{
                this.createPesanan()
            }
        },
        // onChangeDataCustomer(){
        //     window.localStorage.setItem('dataCustomer', JSON.stringify(this.dataCustomer));
        // },
        // calculateTotal(){
        //     let total = 0
        //     // console.log(this.listPesanan)
        //     forEach(this.listPesanan, list =>{
        //         const subtotal = Number(list.harga_jual) * (1-(Number(list.discount) / 100)) * Number(list.qty)
        //         total += subtotal
        //     })
        //     // console.log(total)

        //     this.setTotalHargaPesanan(total)
        // },
        async createPesanan(){
            this.showLoading({ color: 'white' })

            if(this.dataCustomer && this.dataCustomer.company_id == this.userLogin.company_id && this.submissionForCompany){
                forEach(this.listPesanan, list =>{
                    list.discount = 100
                })

                this.calculateTotal()
            }
            // console.log('this.listPesanan', this.listPesanan)

            // if(this.newUser){
            //     this.dataCustomer.username = this.dataCustomer.name.toLowerCase().replace(/\s/g, '')
            //     let responseUser = await this.createUser(this.dataCustomer)
            //     if(responseUser.data.success){
            //         this.showSnackbar({ text: 'Berhasil Membuat User Baru', color: 'green', timeout: 1500 })
            //         partner_id = responseUser.data.attributes.user.id
            //     }else{
            //         forEach(responseUser.data.message, message => {
            //             this.showSnackbar({ text: message[0], color: 'red', timeout: 1500 })
            //         })
            //         this.closeLoading()
            //         return
            //     }
            // }else if(this.userFound){
            //     partner_id = this.dataCustomer.id
            // }

            let response = await this.checkoutPesanan(this.dataCustomer)
            // console.log(response, 'response')

            if(response.data.success){
                this.showSnackbar({ text: 'Berhasil Membuat Order', color: 'green', timeout: 1500 })
                // const responseProduct = await this.dataProducts('ALL')
                // let item_product = []

                // if(responseProduct.data.success){
                //     forEach(responseProduct.data.attributes, data => {
                //         data.harga_jual = Number(data.harga_jual)
                //         data.harga_beli = Number(data.harga_beli)
                //         item_product.push(data)
                //     })

                this.setListProduct([])
                // }else{
                //     this.showSnackbar({ text: responseProduct.data.message, color: 'red', timeout: 1500 })
                // }

                let items = response.data.attributes[0].items

                forEach(items, async item =>{
                    let index = findIndex(this.listPesanan, function(o) { return o.item_name == item.item_name && o.qty == Number(item.qty) ; })
                    if(this.listPesanan[index].mulai && this.listPesanan[index].selesai){
                        const payloadJadwal = {
                            item_id: item.id,
                            product_id: this.listPesanan[index].product_id,
                            start: this.listPesanan[index].mulai,
                            finish: this.listPesanan[index].selesai
                        }
                        await this.createJadwal(payloadJadwal)
                    }
                })

                const responseOrder = await this.getPesanans()
                let item_order = []

                if(responseOrder.status == 200){
                    forEach(responseOrder.data.submission, data => {
                        data.total = Number(data.total)
                        item_order.push(data)
                    })

                    this.setListOrder(item_order)
                }else{
                    this.showSnackbar({ text: 'Error get data', color: 'red', timeout: 1500 })
                }

                this.getDetailOrder(response.data.attributes[0].id)

                // window.localStorage.removeItem('dataCustomer');
                // window.localStorage.removeItem('isEmail', this.isEmail);
                // window.localStorage.removeItem('isTelp', this.isTelp);
                // window.localStorage.removeItem('newUser', this.newUser);
                // window.localStorage.removeItem('userFound', this.userFound);
                // window.localStorage.removeItem('inputSearch', this.inputSearch);
                // this.newUser = false
                // this.userFound = false
                // this.inputSearch = null
                // this.dataCustomer = null
                this.resetPesanan()
                this.setJumlahPayment(Number(response.data.attributes[0].total))
                const payloadCek = {
                    from: dayjs().format('YYYY-MM-DD') + " 00:00:00",
                    to: dayjs().format('YYYY-MM-DD') + " 23:59:00"
                }

                const companyId = JSON.parse(window.localStorage.getItem('company')).id
                // let currentListCheckIn = JSON.parse(window.localStorage.getItem('listJadwalToday'))
                let currentListCheckIn = []
                let now = moment().format('YYYY-MM-DD')
                let attendanceRefs = db.ref('Attendance-'+companyId+'-'+process.env.VUE_APP_ENV)
                await attendanceRefs.child(now).once('value', (snap) => {
                  // console.log('snap.val()', snap.val())
                  if(snap.val() == null){
                    currentListCheckIn = []
                  }else{
                    currentListCheckIn = snap.val()
                  }
                });
                // console.log('currentListCheckIn atas', currentListCheckIn)
                const responseCek = await this.cekJadwal(payloadCek)
                responseCek.data.attributes.forEach(jadwal => {
                  if(jadwal.item.submission_id == response.data.attributes[0].id){
                    currentListCheckIn.push(jadwal)
                  }
                })
                // console.log('currentListCheckIn bawah', currentListCheckIn)

                // window.localStorage.setItem('listJadwalToday', JSON.stringify(currentListCheckIn));
                db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
                  .child(moment().format('YYYY-MM-DD')).set(currentListCheckIn)
                  .then(() => {
                    console.log("Document successfully written!");
                  })
                  .catch((error) => {
                    console.error("Error writing document: ", error);
                  });
                // this.getDetailOrder()
                // this.setDialogPayment(true)
            }else{
              this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
            }

            this.closeLoading()
            this.setSubmissionForCompany(false)
        },
        removePesanan(index){
            let currentPesanan = this.listPesanan
            currentPesanan.splice(index, 1)

            this.setListPesanan(currentPesanan)
            this.calculateTotal()
        },
        logOut(){
            window.localStorage.removeItem('dataCustomer')
            window.localStorage.removeItem('userFound')
            window.localStorage.removeItem('inputSearch')
            this.userFound = false
            this.inputSearch = null
            this.dataCustomer = null
            this.resetPesanan()
            this.dataNewCustomer = {}
        },
        async getDetailOrder(id){
            this.setIdDialogOrder(id)
            await this.detailOrder()
            this.setDialogOrder(true)
        },
        async sendEmailForgotPassword() {
          if (this.emailForgotPassword) {
            let payload = {
              email: this.emailForgotPassword
            }
            try{
              let response = await this.forgotPassword(payload);
              if(response.data.success) {
                this.$notify({
                  group: 'custom-notification',
                  title: 'Success!',
                  text: 'Silahkan cek kotak masuk email anda!',
                  type: 'success',
                  duration: 5000,
                  speed: 1000
                });
              } 
              this.forgotPasswordDialogVisible = false;
            }catch(e) {
              console.log(e)
            }
          }
        },
        async searchUser(){
            if(this.inputSearch != ''){
                this.userFound = false
                // this.newUser = false
                // this.isEmail = false
                // this.isTelp = false
                const response = await this.getUsersByEmailOrPhone(this.inputSearch)
    
                if(response.data != ""){
                    this.dataNewCustomer = response.data
                    this.userFound = true
                    this.dataCustomer = this.dataNewCustomer
                    this.setCustomer(this.dataCustomer)
                    window.localStorage.setItem('dataCustomer', JSON.stringify(this.dataCustomer));
                    window.localStorage.setItem('userFound', this.userFound);
                    window.localStorage.setItem('inputSearch', this.inputSearch);
                }

    
                // if(isNaN(this.inputSearch) && this.inputSearch != ""){
                //     this.isEmail = true
                // }else if(!isNaN(this.inputSearch) && this.inputSearch != ""){
                //     this.isTelp = true
                // }
    
                // window.localStorage.setItem('dataCustomer', JSON.stringify(this.dataCustomer));
                // window.localStorage.setItem('isEmail', this.isEmail);
                // window.localStorage.setItem('isTelp', this.isTelp);
                // window.localStorage.setItem('newUser', this.newUser);
                // window.localStorage.setItem('userFound', this.userFound);
                // window.localStorage.setItem('inputSearch', this.inputSearch);
            }
        },
        pilihCustomer(){
          this.dialogPilihCustomer = true
        }
        // validateEmail(email) { //Validates the email address
        //     var emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        //     return emailRegex.test(email);
        // },
        // validatePhone(phone) { //Validates the phone number
        //     var phoneRegex = /^(\+91-|\+91|0)?\d{10}$/; // Change this regex based on requirement
        //     return phoneRegex.test(phone);
        // },
        // isEmail() {
        //     if (!validateEmail(document.appointment.requiredphone.value) || !validatePhone(document.appointment.requiredphone.value) ){
        //         return false;
        //     }
        // }
    },
    watch: {
        listPesanan() {
            this.calculateTotal()            
        },
        valid() {
            window.localStorage.setItem('validatorOrder', this.valid);
        }
    }
}
</script>
<style>
.styled-input {
    transform: scale(0.850);
    font-size: 15px!important;
  /* height: 10px;
  font-size: 12pt; */
}

.v-label {
    font-size:15px!important;
}

.text-decoration-none {
  text-decoration: none;
}
</style>